import React, { useState, useEffect, useCallback, useRef } from 'react';

import axios from 'axios';
import {API_URL} from '../../constants';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import './listado.css';
import { loadingPrincipal } from '../../functions';


  const Listado  = () =>  {

    Moment.updateLocale('en', {
        months : [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
            "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
        ]
    });

    Moment.updateLocale('en', {
        weekdays : [
            "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
        ]
    });

    const YEARS = () => {
        const years = []
        const dateStart = Moment().add(-2, 'y')
        const dateEnd = Moment() 
        while (dateEnd.diff(dateStart, 'years') > 0) {
            dateStart.add(1, 'year')
            years.push(dateStart.format('YYYY'))
        }
        return years
       }

    const [sector, setSector] = useState([]);
    const [mes, setMes] = useState([]);
    const [anio, setAnio] = useState([]); 
    const [lastBulletin, setLastBulletin] = useState([]); 
    const [bulletin, setBulletin] = useState([]); 

    const [currentSector, setCurrentSector] = useState([]); 
    const [currentSectorCode, setCurrentSectorCode] = useState([]); 
    const [currentAnio, setCurrentAnio] = useState([]); 
    const [currentMes, setCurrentMes] = useState([]); 
    const [currentPage, setCurrentPage] = useState([]); 

    
    const CURRENT_ANIO = Moment().format('YYYY');
    const CURRENT_MONTH = Moment().format('M');

    
    useEffect(() => {

        loadingPrincipal(true);  // Show charging view
    
        const url = `${API_URL}SectorUX/`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            setSector(data.result.filter(item=> item.sCodigoPP!==null && item.sClave!=="MULT"));  
            setCurrentSector(data.result[0].sDescripcion);
            setAnio(YEARS());
            setMes(MONTHS(CURRENT_ANIO));
            setCurrentMes(CURRENT_MONTH);
            setCurrentAnio(CURRENT_ANIO);
            setCurrentPage(1);
        }).catch(error => {
          console.log(error)
        });
    
    }, []); 
 

    useEffect(() => {   
    var sectorCode = 0;
    if (sector.length>0) 
        sectorCode = sector[0].sCodigoPP;

    const url = `${API_URL}BulletinUX/1/X/0/${sectorCode}`;
    axios.get(url).then(response => response.data)
    .then((data) => {
        var newData = data.result.filter(item=> Moment(item.dFechaPublicacion).format('M')==CURRENT_MONTH && Moment(item.dFechaPublicacion).format('YYYY')==CURRENT_ANIO);
        setLastBulletin(newData[0]);
        setBulletin(newData.slice(1,newData.length));
        loadingPrincipal(false);
        setCurrentSectorCode(sectorCode);
    })
    .catch(error => {
    });

    }, [sector])
      
      const MONTHS = (Anio) => {
        const months = []
        const dateStart = Moment([Anio])

        if (Moment().format('YYYY')===Anio)
        {
            for (var i=0; i < Moment().format('M'); i++)
            {
                months.push(dateStart.format('MMMM'))
                dateStart.add(1, 'month')
            }
        } else 
        {
            for (var i=0; i < 12; i++)
            {
                months.push(dateStart.format('MMMM'))
                dateStart.add(1, 'month')
            }
        }

        return months
       }

    const onChangeSector= (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        setCurrentSectorCode(event.target.value);
        setCurrentSector(event.nativeEvent.target[index].text);
        onRenderBulletin(event.target.value, currentAnio, currentMes);
    }

    const onChangeAnio= (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        setCurrentAnio(event.target.value)
        setMes(MONTHS(event.target.value));
        onRenderBulletin(currentSectorCode, event.target.value, currentMes);
    }

    const onChangeMes= (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        setCurrentMes(event.target.value);
        onRenderBulletin(currentSectorCode, currentAnio, event.target.value);
    }

    const onRenderBulletin=(sector, anio, mes) => {

        const url = `${API_URL}BulletinUX/${currentPage}/X/0/${sector}`;
        console.log('url=' + url);

        axios.get(url).then(response => response.data)
        .then((data) => {

            var newData = data.result.filter(item=> Moment(item.dFechaPublicacion).format('M')==mes && Moment(item.dFechaPublicacion).format('YYYY')==anio);
            setLastBulletin(newData[0]);
            setBulletin(newData.slice(1, newData.length));
            loadingPrincipal(false);
        })
        .catch(error => {
        });
    }

    return (
      <div className="main" >
        <br/>
        <br/>
        <div className="boletin__section_listado">
            <div className="boletin__section_listado">
                <br/>
                <div className="last-list__row">
                    <div className="" >
                        <div className="row boletin__filters section__margin-bottom ">
                                <div className="col-sm-4 select_box">
                                <span className="select-arrow fas fa-sort-amount-down"></span>
                                <select className="form-control dropdown__form-control" onChange={onChangeSector} >
                                    {/* <option value={0}>SELECCIONE EL SECTOR</option> */}
                                    {
                                    sector.map((item, index) => (
                                        <option selected={(index===0?true:false)} value={item.sCodigoPP}>{item.sDescripcion}</option>
                                    ))
                                    }
                                    
                                </select>
                                </div>
                                <div className="col-sm-2 select_box">
                                    <span className="select-arrow fa fa-chevron-down"></span>
                                    <select className="form-control text-filter__form-control" onChange={onChangeAnio}>
                                        <option>AÑO</option>
                                        {
                                        anio.map((item, index) => (
                                        <option value={item} selected={CURRENT_ANIO===item?true:false}>{item}</option>
                                        ))
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-2 select_box">
                                    <span className="select-arrow fa fa-chevron-down"></span>
                                    <select className="form-control text-filter__form-control" onChange={onChangeMes} >
                                            <option>MES</option>
                                            {
                                            mes.map((item, index) => (
                                            <option value={index+1} selected={CURRENT_MONTH-1===index?true:false}>{item}</option>
                                            ))
                                            }
                                    </select>
                                </div>

                                <div className="col-sm-4">
                                    <input type="text" className="form-control text-filter__form-control" placeholder="PALABRA ASOCIADA O CONCRETA" />
                                </div>
                            </div>
                    </div>
                </div>
            
                <div class="title">
                    <div class="col-sm-12 m-b-sm header-title--col">
                            <ul id="header-title">
                                <li class="header-title__subtitle-name font-21">
                                        <span style={{ textTransform: 'uppercase'}} class="header-title__subtitle-name--pl">TODOS LOS BOLETINES DE {currentSector}</span>
                                    <span hidden={true} class="header-title__subtitle-name--pl">SIN RESULTADOS </span>
                                </li>
                            </ul>
                    </div>
                </div>
                <div class="title" hidden={true} >
                    <div class="col-sm-12 boletines-download">
                        <p class="boletines-download__text">
                            <span class="boletines-download__text-zip">Descargar todos (zip)
                                <span class="boletines-download__icon"><i class="fas fa-cloud-download-alt"></i></span>
                            </span> 
                        </p>
                    </div>
                </div>

                <div  hidden={lastBulletin===undefined || lastBulletin.length===0?true:false} class="m-b-lg">
                    <div class=" m-b-sm">
                        <div class="col-sm-12">
                            <p class="boletines__year">Último</p>
                        </div>
                    </div>
                </div>
               
               
                <div hidden={lastBulletin===undefined || lastBulletin.length===0?true:false} className="last-list__row">
                    <div className="" >
                        <div className="row boletin__filters section__margin-bottom ">
                            <div className="col-sm-3 select_box">
                            {lastBulletin===undefined || lastBulletin.length===0?'':Moment(lastBulletin.dFechaPublicacion).format('dddd') + ', ' +  Moment(lastBulletin.dFechaPublicacion).format('DD MMMM yyyy')}
                            </div>
                            <div className="col-sm-9 select_box">
                                <p class="boletin-item__name"> <Link target={"_blank"} to={'/' + (lastBulletin===undefined?'':lastBulletin.nBoletinCodigo) }> {lastBulletin===undefined?'':lastBulletin.nBoletinCodigo}.- {lastBulletin===undefined ?'':lastBulletin.sTitulo} </Link></p>
                                <p class="boletin-item__options">
                                <Link target={"_blank"} to={'/' + (lastBulletin===undefined?'':lastBulletin.nBoletinCodigo) }>
                                        <span class="boletin-item__option-icon"><i class="fas fa-eye"></i></span> {lastBulletin===undefined || lastBulletin.length===0?'':lastBulletin.nVistas} 
                                </Link>
                                          {/* &nbsp;| &nbsp; */}
                                        {/* <span hidden={true} class="boletin-item__option-icon"><i class="fas fa-cloud-download-alt"></i></span> {lastBulletin===undefined || lastBulletin.length===0?'':lastBulletin.nDescargas} */}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="last-list__row"/>

                <div class="m-b-lg" hidden={bulletin.length===0?true:false}>
                    <div class=" m-b-sm">
                        <div class="col-sm-12">
                            <p class="boletines__year">{currentAnio}</p>
                        </div>
                    </div>
                </div>
               
               
                <div className="last-list__row">
                    <div className="" >
                    {
                    bulletin.map((item, index) => (
                        <div className="row boletin__filters section__margin-bottom ">
                            <div className="col-sm-3 select_box">
                            {Moment(item.dFechaPublicacion).format('dddd') + ', ' +  Moment(item.dFechaPublicacion).format('DD MMMM yyyy')}
                            </div>
                            <div className="col-sm-9 select_box">
                                <p class="boletin-item__name"> <Link target={"_blank"} to={'/' + item.nBoletinCodigo }>  {item.nBoletinCodigo}.- {item.sTitulo} </Link> </p>
                                <p class="boletin-item__options">
                                <Link target={"_blank"} to={'/' + item.nBoletinCodigo }>
                                    <span class="boletin-item__option-icon"><i class="fas fa-eye"></i></span> {item.nVistas}
                                </Link>
                                   {/* &nbsp;| &nbsp; */}
                                        {/* <span class="boletin-item__option-icon"><i class="fas fa-cloud-download-alt"></i></span> {item.nDescargas} */}
                                </p>
                            </div>
                        </div>
                    ))
                    }
                    
                    <br/>

                    </div>
                </div>

            </div>
        </div>
      </div>
    );
}

export default Listado;


  